
//----------------------------------------------    Color Variables   --------------------------------------------------------------//


export const text = '#000000';
export const hover = '#F27A21';
export const white = '#FFFFFF';
export const marengo = '#525F6E';
export const darkBrown = '#3D342D';
export const grayText = '#D7D8DA';
export const bg = '#E9E9E9';
export const Black = '#000';


//----------------------------------------------    Font Variables   --------------------------------------------------------------//

export const title = `"Banana Grotesk", Arial, Helvetica, freesans, sans-serif `;
export const book = `"Avenir LT Pro 45 Book"`;
export const black = `"Avenir LT Pro 65 black"`;
export const heavy = `"Avenir LT Pro Heavy"`;
// export const medium = `"Avenir LT Pro 65"`;
export const light = `"Banana Grotesk light"`;
export const bold = `"Banana Grotesk bold"`;
export const semiBold = `"Banana Grotesk semi bold"`;
export const extraLight = `"Banana Grotesk extra light"`;
export const extraBold = `"Banana Grotesk extra bold"`;
export const medium = `"Banana Grotesk medium"`;
export const thin = `"Banana Grotesk thin"`;
export const regular = "Banana Grotesk regular";



//
export const whites = '#F5F5F5';
export const ease = 'cubic-bezier(0.4, 0, 0, 1)';
export const body = `Banana Grotesk, Arial, Helvetica, freesans, sans-serif`


export const Transition = "cubic-bezier(0.4, 0, 0, 1)";
